import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-public-access-overlays',
  templateUrl: './public-access-overlays.component.html',
  styleUrl: './public-access-overlays.component.scss'
})
export class PublicAccessOverlaysComponent {
  @Input() publicInfoVisible = false;
  @Input() aboutRamVisible = false;

  @Output() publicInformationToggled = new EventEmitter<void>();
  @Output() aboutRamClosed = new EventEmitter<void>();
}
